export default {
  "Loop as a GIF": "Bir GIF olarak döngü",
  "without sound": "ses olmadan",
  "Final output duration": "Nihai çıktı süresi",
};
